import { render } from "./SeleccionarDireccionModal.vue?vue&type=template&id=5cbb0f3e"
import script from "./SeleccionarDireccionModal.vue?vue&type=script&lang=js"
export * from "./SeleccionarDireccionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__